import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { getStatusTranslationKey } from '../../../utils/get-translation-key';

interface Props {
	status: number;
}

function StatusCell({ status }: Props) {
	const { t } = useTranslation();

	return <span className={`status-circle task-status-${status}`} title={t(getStatusTranslationKey(status))} />;
}

export default memo(StatusCell);
